import { render, staticRenderFns } from "./addSign.vue?vue&type=template&id=237cbaa2&scoped=true"
import script from "./addSign.vue?vue&type=script&lang=js"
export * from "./addSign.vue?vue&type=script&lang=js"
import style0 from "./addSign.vue?vue&type=style&index=0&id=237cbaa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cbaa2",
  null
  
)

export default component.exports